import { useFormikContext } from 'formik';
import * as React from 'react';
import { useEffect } from 'react';

import { RadioApplicationDto } from 'api-client';

import ShipCallsign from '../../../certificate_management/callsign/components/ShipCallsign';
import { useLicenceApi } from '../../LicenceApiHooks';

const ShipDetailsSection = () => {
  const { values, setFieldValue } = useFormikContext<RadioApplicationDto>();
  const { validateLicenceShipCallsign, validateLicenceClientVesselName } = useLicenceApi();

  useEffect(() => {
    setFieldValue('clientId', values.applicant);
  }, [values.applicant]);

  return (
    <ShipCallsign
      serviceType="LICENCE_SHIP"
      validateShipCallsignFn={validateLicenceShipCallsign}
      validateClientVesselNameFn={validateLicenceClientVesselName}
    />
  );
};

export default ShipDetailsSection;
